import { config as confFunc } from 'env_def';
import { WxBindStatus, } from '@/api/logical/notification_center';
import { api } from '@/api/api';
import { inWindow } from '@/config';
const sseHost = confFunc('sseHost');
export class NotificationCenterApiImpl {
    constructor() {
        this.name = 'notificationCenterApiImpl';
        this.eventApi = api.getEventApi();
        this.edmGlobalNoticeCheckHandle = {
            eventPeriod: 'long',
            handler: ob => {
                if (ob.seq > 0 && this.systemApi.getCurrentUser()) {
                    this.checkNotice();
                }
            },
            id: 'edmNoticeCheck',
            seq: 0,
        };
        this.httpApi = api.getDataTransApi();
        this.systemApi = api.getSystemApi();
    }
    init() {
        return this.name;
    }
    async getNotificationGroup() {
        const url = this.systemApi.getUrl('getNotificationGroup');
        const res = await this.httpApi.post(url, {}, { contentType: 'json' });
        const { success, data, error } = res.data || {};
        if (success && data) {
            return data;
        }
        console.error('notifyCenter getNotificationGroup', error);
        throw error;
    }
    async getNotificationList(req) {
        const url = this.systemApi.getUrl('getNotificationList');
        const res = await this.httpApi.post(url, req, { contentType: 'json' });
        const { success, data, error } = res.data || {};
        if (success && data) {
            return data;
        }
        console.error('notifyCenter getNotificationList', error);
        throw error;
    }
    async getNotificationQuickList(req) {
        const url = this.systemApi.getUrl('getNotificationQuickList');
        const res = await this.httpApi.get(url, req);
        const { success, data, error } = res.data || {};
        if (success && data) {
            return data;
        }
        console.error('notifyCenter getNotificationQuickList', error);
        throw error;
    }
    async getNotificationOutList() {
        const url = this.systemApi.getUrl('getNotificationOutList');
        const res = await this.httpApi.get(url);
        const { success, data, error } = res.data || {};
        if (success && data) {
            return data;
        }
        console.error('notifyCenter getNotificationOutList', error);
        return { items: [] };
    }
    async getNotificationQuickListCount() {
        const url = this.systemApi.getUrl('getNotificationQuickListCount');
        const res = await this.httpApi.get(url);
        const { success, data, error } = res.data || {};
        if (success && data) {
            return data;
        }
        console.error('notifyCenter getNotificationQuickListCount', error);
        throw error;
    }
    async updateNotificationAllRead() {
        const url = this.systemApi.getUrl('updateNotificationAllRead');
        const res = await this.httpApi.post(url, undefined, { contentType: 'json' });
        const { success, data, error } = res.data || {};
        if (success && data) {
            return;
        }
        console.error('notifyCenter updateNotificationAllRead', error);
        throw error;
    }
    async batchUpdateNotificationRead(req) {
        const url = this.systemApi.getUrl('batchUpdateNotificationRead');
        const res = await this.httpApi.post(url, { ids: req }, { contentType: 'json' });
        const { success, data, error } = res.data || {};
        if (success && data) {
            return;
        }
        console.error('notifyCenter batchUpdateNotificationRead', error);
        throw error;
    }
    async batchUpdateNotificationDelete(req) {
        const url = this.systemApi.getUrl('batchUpdateNotificationDelete');
        const res = await this.httpApi.post(url, { ids: req }, { contentType: 'json' });
        const { success, data, error } = res.data || {};
        if (success && data) {
            return;
        }
        console.error('notifyCenter batchUpdateNotificationDelete', error);
        throw error;
    }
    async connectNotificationSSE() {
        var _a;
        const random = Math.floor(Math.random() * 9000) + 1000;
        const sessionId = (((_a = this.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.accountMd5) || '') + new Date().getTime().toString(16) + random.toString(16);
        const url = `${sseHost}/api/biz/rt-msg/connect?sessionId=${encodeURIComponent(sessionId)}`;
        return new EventSource(url, { withCredentials: true });
    }
    async getWxBindStatus() {
        const url = this.systemApi.getUrl('getWxBindStatus');
        const res = await this.httpApi.get(url);
        const { success, data } = res.data || {};
        if (success && data) {
            return data.wxBindStatus || WxBindStatus.unbind;
        }
        return WxBindStatus.unbind;
    }
    async getWxQrCode() {
        const url = this.systemApi.getUrl('getWxQrCode');
        const res = await this.httpApi.get(url);
        const { success, data } = res.data || {};
        if (success && data) {
            return data;
        }
        return undefined;
    }
    async getWxScanStatus(qrCodeId) {
        const url = this.systemApi.getUrl('getWxScanBindStatus');
        const res = await this.httpApi.get(url, { qrCodeId });
        const { success, data } = res.data || {};
        if (success && data) {
            return data;
        }
        return undefined;
    }
    async getNotice() {
        try {
            const { data } = await this.httpApi.get(this.systemApi.getUrl('getEdmNotice'));
            if (!data || !data.success) {
                return Promise.reject(data === null || data === void 0 ? void 0 : data.message);
            }
            return data === null || data === void 0 ? void 0 : data.data;
        }
        catch (err) {
            return Promise.reject(err);
        }
    }
    checkNotice() {
        if (process.env.BUILD_ISEDM) {
            return Promise.resolve();
        }
        if (inWindow() && window.isAccountBg) {
            return Promise.resolve();
        }
        return this.getNotice().then(data => {
            if (data.code === 0) {
                this.eventApi.sendSysEvent({
                    eventName: 'edmGlobalNotice',
                    eventStrData: '',
                    eventData: data,
                    eventSeq: 0,
                });
            }
        });
    }
    afterInit() {
        if (inWindow() && process.env.BUILD_ISEDM) {
            this.checkNotice();
            this.systemApi.intervalEvent(this.edmGlobalNoticeCheckHandle);
        }
        return this.name;
    }
}
const notificationCenterApiImpl = new NotificationCenterApiImpl();
api.registerLogicalApi(notificationCenterApiImpl);
export default notificationCenterApiImpl;
